import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import {connect} from "react-redux";
import {getLabel} from "../../language";

const mapStateToProps = state => ({
    currentUser: state.common.currentUser,
    anonymousMode: state.user.anonymousMode
});

const TagsModal = ({ showTagModal, anonymousMode,setTags,onHide }) => (
    <Modal show={showTagModal} onHide={onHide} className={`audience ${anonymousMode ? "dark" : ""}`}>
        <Modal.Header>
            <Modal.Title>
                {getLabel(327)}
            </Modal.Title>
            <button type="button" className="close" data-dismiss="modal" onClick={onHide} aria-hidden={showTagModal}>×</button>
        </Modal.Header>
        <Modal.Body>
            <div className={"form-group "}>
                {getLabel(328)}
            </div>
        </Modal.Body>
        <Modal.Footer style={{height: "50px"}}>
            <Button onClick={()=>setTags()} className={`m-t-30 btn-primary${!setTags ? "-dark" : " custom-dp"}`}>{getLabel(281)}</Button>
            <Button onClick={onHide} className={`m-t-30 btn-primary${!onHide ? "-dark" : " custom-dp"}`}>{getLabel(103)}</Button>
        </Modal.Footer>
    </Modal>
)
export default connect(mapStateToProps, null)(TagsModal)


